export default __webpack_public_path__ + "static/media/photo_2023-08-11_17-42-23-removebg-preview.63114919.png";